import React from 'react'
import { connect } from "react-redux";
import { GetParamsData } from '$Deposits/lib/LibCommonData'
export class SubmitBtn extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
            isTemplyDisableSubmitButton: false, //是否暫時disable submit button
        };
	}

    onSubmit = () => {
        const {onPress, submitBtn = () => { return true }} = this.props;
        const {isTemplyDisableSubmitButton} = this.state;
        const isTreu = submitBtn() && !isTemplyDisableSubmitButton; 

        if(isTreu){
            this.setState({
                isTemplyDisableSubmitButton:true
            });
    
            setTimeout(()=>{
                this.setState({
                    isTemplyDisableSubmitButton:false
                })
            },3000);
            onPress();
        }
    };

    render() {
        const { submitBtn = () => { return true }, submitBtnItem = 'ถัดไป', OldBankLine } = this.props
        const { bonusName } = GetParamsData() || {}
        const {isTemplyDisableSubmitButton} = this.state;
        const isTreu = submitBtn() && !isTemplyDisableSubmitButton; 
        return (
            <>
                {
                    !!bonusName &&
                    <div>
                        <p className='inputTitle'>โปรโมชั่น</p>
                        <div className='inputView disabled'>{bonusName}</div>
                    </div>
                }
                {!!OldBankLine && OldBankLine}
                <div
                    className={isTreu ? 'submitBtnActive' : 'submitBtn'}
                    onClick={this.onSubmit}
                >
                    {submitBtnItem}
                </div>
            </>
        )
    }
}

const mapStateToProps = state => ({
    DepositNextStep: state.DepositNextStep,
    DepositSuccessPage: state.DepositSuccessPage,
    DepositOldBankSixNumberStatus: state.DepositOldBankSixNumberStatus,
    DepositMoneyStatus: state.DepositMoneyStatus,
    DepositMemberBanksActive: state.DepositMemberBanksActive,
    DepositDateSelect: state.DepositDateSelect,
    DepositTimeSelect: state.DepositTimeSelect,
});
const mapDispatchToProps = {

};
export default connect(mapStateToProps, mapDispatchToProps)(SubmitBtn);
